import { Fragment, useState } from 'react';

import FeaturesContent from '../../components/layout/features/features-content';
import FeaturesImageModal, {
  type FeatureModalImage,
} from '../../components/layout/features/features-image-modal';

export default function Features() {
  const [selectedImage, setSelectedImage] = useState<FeatureModalImage | null>(null);

  return (
    <Fragment>
      <FeaturesContent onOpenImage={setSelectedImage} />
      <FeaturesImageModal
        image={selectedImage}
        isOpen={Boolean(selectedImage)}
        onClose={() => setSelectedImage(null)}
      />
    </Fragment>
  );
}
